// solanaUtils.ts
import { Connection, PublicKey } from '@solana/web3.js';
import { SOLANA_RPC_URL } from '..';

/**
 * Retrieves the SOL balance for a given Solana wallet address.
 * @param address - The wallet address as a string.
 * @returns The balance in SOL as a number.
 */
export const getSolBalanceByAddress = async (address: string): Promise<number> => {
    try {
        const connection = new Connection(SOLANA_RPC_URL, "confirmed");
        const publicKey = new PublicKey(address);
        const lamports = await connection.getBalance(publicKey);
        const solBalance = lamports / 1e9;
        return solBalance;
    } catch (error) {
        console.error('Error fetching SOL balance:', error);
        throw error;
    }
};
